import { createFileRoute } from "@tanstack/react-router";
import AzBlueInsurance, { config } from "@/pages/AzBlueInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/az-blue-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "AZ Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Arizona Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "AZ Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Arizona Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/az-blue-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/az-blue-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AzBlueInsurance />;
}
